import React, {useMemo} from 'react';

import ListView from '@/components/explorer/view/ListView/ListView';
import {useWifiListContext} from '@/contexts/WifiListContext';

import AvailableWifiList from './AvailableWifiList';
import NotAvailableWifiList from './NotAvailableWifiList';
import WaitingAvailableWifiList from './WaitingAvailableWifiList';

function AvailableWifiListContainer() {
  const {wifiList} = useWifiListContext();
  console.log({wifiList});

  const dataState = useMemo(() => {
    if (wifiList && wifiList.length === 0) return ListView.state.NO_DATA;
    if (wifiList === null) return ListView.state.WAITING_DATA;
    return ListView.state.AVAILABLE_DATA;
  }, [wifiList]);

  // eslint-disable-next-line no-nested-ternary
  return dataState === ListView.state.NO_DATA ? (
    <NotAvailableWifiList />
  ) : dataState === ListView.state.WAITING_DATA ? (
    <WaitingAvailableWifiList />
  ) : (
    <AvailableWifiList />
  );
}
export default AvailableWifiListContainer;
